export default {
    name: " Enquiry & Sales Execution",
    meta: {
        icon: "note_add",
        expanded: true,
        auth: true
    },

    departmentName: "Enquiry & Pricing",
    finalPagePermision: "",

    children: [
        // {

        //     name: "Lead",
        //     keywords: ['Lead'],
        //     permissionName: 'Lead',
        //     path: "/lead/leadlist",
        //     meta: {
        //         icon: "note_add",
        //         auth: true
        //     },
        //     component: require("../component/Lead/leadList.vue"),
        //     finalPagePermision: "",

        // },
        {

            name: "Enquiry",
            keywords: ['Enquiry'],
            permissionName: 'Enquiry',
            path: "/mainEnquiry/mainEnquiry",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/allModuleForm/mainEnquiry.vue"),
            finalPagePermision: "",

        },
        {

            name: "Enquiry &  Quotation Details",
            keywords: ['Enquiry &  Quotation Details', 'Enquiry'],
            permissionName: 'Enquiry',
            path: "/viewMainEnquiryDetails/viewMainEnquiryDetails",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/allModuleForm/viewMainEnquiryDetails.vue"),
            finalPagePermision: "",

        },

        {
            name: "Sales Execution Details",
            keywords: ['Sales Execution Details', 'Enquiry'],
            permissionName: 'Enquiry',
            path: "/viewAllModuleDetails/viewAllModuleDetails",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/allModuleForm/viewAllModuleDetails.vue"),
            finalPagePermision: "",

        },

        {
            name: "Agent & Coloader ",
            path: "/common/agentColoader/",
            keywords: ['Agent & Coloader', 'Sales Execution Details', 'Enquiry'],
            permissionName: 'Agent & Coloader',
            meta: {
                icon: "supervised_user_circle",
                auth: true
            },
            finalPagePermision: "",
            component: require("../component/freightForwarding/agentColoader/agentColoaderForm.vue")
        },

        {
            name: "Console Booking ",
            path: "/common/consoleBooking/",
            keywords: ['Agent & Coloader', 'Sales Execution Details', 'Enquiry', 'Console Booking'],
            permissionName: 'Console Booking',
            meta: {
                icon: "supervised_user_circle",
                auth: true
            },
            finalPagePermision: "",
            component: require("../component/consoleBooking/ConsoleBooking.vue")
        }




    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/allModuleForm.js